import React from "react";
import logger from "logger";

/**
 import { StringMap } from "./StringMap";
 <StringMap
          label={"Selected Cities"}
          valueMap={task.taskstatusdetail.selectedcities}
          valueParser={(k, v) => getCityGenericNameFromNumber(k)}
        />
 */

export const StringMap = ({ label, valueMap, valueParser }) => {
  return (
    <>
      <div className="infokey">{label}</div>
      {valueMap &&
        Object.keys(valueMap).map((key) => {
          const value = valueMap[key];
          return (
            <div key={key}>
              {value && (
                <div>
                  <div className="infovalue" style={{"fontSize": "15px"}}>
                    {valueParser(key, value)}
                  </div>
                </div>
              )}
            </div>
          );
        })}
    </>
  );
};
